// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__gvhfb","header":"Panel_header__lks07","left":"Panel_left__k6y0l","right":"Panel_right__aDlbx","divider":"Panel_divider__Sychj","body":"Panel_body__mHfxs"};